<template>
<Modal :value="value" 
       @on-visible-change="val=>$emit('input',val)" 
       class="creative-library"
       title="创意库选择"
       width="770"
       :mask-closable="false"
       :transfer="true">
    <!-- 创意库 -->
    <section class="creative-library-body">
        <!-- 图库 -->
        <Tabs v-model="creativeParams.creativeSource" @on-click="getCreativeList(true)">
            <TabPane label="我的图库" name="1"></TabPane>
            <TabPane label="共享图库" name="2"></TabPane>
            <TabPane label="FB图库" name="3"></TabPane>
        </Tabs>
        <!-- 筛选栏 -->
        <div class="function-bar">
            <div class="function-item">
                <span class="function-label">尺寸：</span>
                <Select @on-change="getCreativeList(true)" v-model="creativeParams.sizeType" class="function-select" filterable>
                    <Option :value="0" label="不限">不限</Option>
                    <Option  v-for="(value,key) in sizeList[creativeType]"
                            :key="key"
                            :value="key">
                            <p class="showregular">{{ value }}</p>
                    </Option>
                </Select>
            </div>
            <div class="function-item">
                <span class="function-label">行业：</span>
                <Select @on-change="getCreativeList(true)" v-model="creativeParams.campaignTypeId" class="function-select middle" filterable>
                    <Option :value="0" label="不限">不限</Option>
                    <OptionGroup v-for="item in campaignTypeList" :key="item.level1Type" :label="item.level1Type==1?'APP':'电商'">
                        <Option v-for="campaignType in item.campaignSubTypes"
                                :value="campaignType.type"
                                :key="campaignType.type"
                                :label="campaignType.name"
                                :title="campaignType.name">
                                <p class="showregular">{{ campaignType.name }}</p>
                        </Option>
                    </OptionGroup>
                </Select>
            </div>
            <div class="function-item">
                <span class="function-label">产品：</span>
                <Select @on-change="getCreativeList(true)" v-model="creativeParams.appid" class="function-select long" filterable>
                    <Option :value="0" name="不限">不限</Option>
                    <Option v-for="(item,index) in appList"
                            :key="index"
                            :value="item.appid"
                            :label="item.appid">
                            <p class="showregular" :title="item.appid">{{ item.appid }}</p>
                    </Option>
                </Select>
            </div>
        </div>
        <div class="scroll-box">
            <div v-if="creativeList.length" @scroll="onScroll($event)" class="creative-list" :style="{overflow:loading?'hidden':'auto'}">
                <div v-for="(item,index) in creativeList" 
                    @click="item.selected=!item.selected"
                    :key="`${item.id}_${index}`" class="creative-item"
                    :class="{selected:item.selected}">
                    <img :src="item.imgUrl" />
                    <span @click.stop="preview(item)" class="icon-preview"><Icon type="ios-search-strong"></Icon></span>
                </div>
            </div>
            <div class="creative-list no-data" v-else>暂无匹配数据</div>
            <cSpin v-if="loading" :size="0.14" color="#23c52f" background="rgba(255,255,255,0.8)"></cSpin>
        </div>
    </section>
    <footer class="footer" slot="footer">
        <span class="footer-left">已选<i class="selected-count">{{selectedCount}}</i>项</span>
        <div class="footer-left">
            <Button type="text"
                    size="large"
                    @click="$emit('input',false)">取消</Button>
            <Button type="primary"
                    size="large"
                    @click="onSubmit">提交</Button>
        </div>
	</footer>
</Modal>
</template>
<script>
import cSpin from '@/components/commons/cSpin.vue';
import { Button } from 'iview';
export default {
    name: 'creativeLibrary',
    components: { cSpin },
    props: {
        value: {
            type: Boolean,
            default: () => [],
        },
        creativeType: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            loading: false,
            creativeList: [], //创意列表
            //获取创意列表的参数
            creativeParams: {
                creativeType: 1,
                creativeSource: '1',
                sizeType: 0,
                campaignTypeId: 0,
                appid: 0,
                page: 1,
                pageSize: 50,
            },
            requestSource: '',
            timeout: '',
        };
    },
    computed: {
        seriesParams() {
            return this.$store.state.newPromotion.seriesParams;
        },
        //国家列表
        countryList() {
            return this.$store.state.newPromotion.countryList;
        },
        //行业媒体列表
        campaignTypeList() {
            return this.$store.state.newPromotion.campaignTypeList;
        },
        //媒体包名列表
        appList() {
            return this.$store.state.newPromotion.appList;
        },
        //尺寸列表 0：全部 1：图片创意 2：信息流
        sizeList() {
            return {
                0: this.$store.state.newPromotion.sizeList,
                1: this.$store.state.newPromotion.imgSizeList,
                2: this.$store.state.newPromotion.infoImgSizeList,
            };
        },
        selectedArr() {
            return this.creativeList.filter(item => item.selected);
        },
        selectedCount() {
            return this.selectedArr.length;
        },
        imgTemplate() {
            return this.$store.state.newPromotion.imgTemplate;
        },
        infoTemplate() {
            return this.$store.state.newPromotion.infoTemplate;
        },
    },
    watch: {
        value: {
            handler: function(newVal) {
                document.body.className = newVal ? 'overflow-hidden' : 'overflow-auto';
                if (this.value) {
                    this.$nextTick(() => {
                        this.creativeParams = {
                            ...this.creativeParams,
                            campaignTypeId: this.seriesParams.campaignType ? ~~this.seriesParams.campaignType : 0,
                            appid: this.seriesParams.appBundle ? this.seriesParams.appBundle : 0,
                        };
                        this.getCreativeList(true);
                    });
                }
            },
            immediate: true,
        },
        creativeType: {
            handler: function(newVal) {
                this.creativeParams.creativeType = newVal;
            },
            immediate: true,
        },
    },
    methods: {
        /**
         * @desc 获取创意列表
         * @param {Boolean} isInit:是否初始化页数
         */
        async getCreativeList(isInit = false) {
            if (isInit) this.creativeParams.page = 1;
            //滚动加载的时候切换了筛选条件
            if (this.requestSource) this.requestSource.cancel('cencel');
            clearTimeout(this.timeout);
            this.loading = true;
            this.requestSource = this.$axios.CancelToken.source();
            const creativeParams = this.creativeParams;
            const params = {
                ...creativeParams,
                sizeType: creativeParams.sizeType ? creativeParams.sizeType : '',
                campaignTypeId: creativeParams.campaignTypeId ? creativeParams.campaignTypeId : '',
                appid: creativeParams.appid ? creativeParams.appid : '',
            };
            if (creativeParams.creativeType == 2) params.creativeType = '2,5';
            const res = await this.$axios.get(this.$port.manager.getCreativeList, {
                params,
                cancelToken: this.requestSource.token,
                cancelLoading: true,
            });
            this.timeout = setTimeout(() => (this.loading = false), 300);
            const arr = res.data.list || [];
            arr.forEach(item => (item.selected = false));
            if (isInit) this.creativeList = [...arr];
            else this.creativeList.push(...arr);
        },
        /**
         * @desc 提交
         */
        onSubmit() {
            if (!this.selectedArr.length) {
                this.$Message.error({ content: '请至少选择1张图片', dutation: 2 });
                return;
            }
            const arr = this.selectedArr.map(item => {
                let val = {};
                if (item.creativeType == 1) val = { ...this.imgTemplate, ...item };
                if (item.creativeType == 2 || item.creativeType == 5) {
                    val = {
                        ...item,
                        name: item.title,
                        creativeType: item.creativeType,
                        status: 1,
                    };
                }
                val.creativeId = val.id;
                delete val.id;
                return val;
            });
            this.$emit('submit', [...arr]);
            this.$emit('input', false);
        },
        /**
         * @desc 滚动加载
         * @param {Event:Object} e:事件对象
         */
        async onScroll(e) {
            if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
                this.creativeParams.page += 1;
                this.getCreativeList();
            }
        },
        /**
         * @desc 预览创意
         * @param {Object} item:创意对象
         */
        preview(item) {
            const sizeLabel = this.sizeList[0][item.sizeType];
            const size = sizeLabel.split('x');
            [size[0], size[1]] = [~~size[0], ~~size[1]];
            if (item.creativeType == 1) {
                if (size[1] == 480) [size[0], size[1]] = [240, 320];
                this.$Modal.info({
                    title: `图片：${sizeLabel}`,
                    render: h =>
                        h('img', {
                            class: 'preview-img',
                            attrs: { src: item.imgUrl },
                            style: { width: `${size[0]}px`, height: `${size[1]}px` },
                        }),
                    width: size[0] + 40 > 418 ? size[0] + 40 : 418,
                    okText: '关闭',
                });
            }
            if (item.creativeType == 2 || item.creativeType == 5) {
                this.$Modal.info({
                    title: `信息流：${sizeLabel}`,
                    render: h =>
                        h('div', { class: 'preview-info' }, [
                            h('img', {
                                class: 'preview-img',
                                attrs: { src: item.imgUrl },
                                style: { width: '320px', height: '200px' },
                            }),
                            h('div', { class: 'preview-info-bottom', style: { width: '320px' } }, [
                                h('img', { class: 'preview-icon', attrs: { src: item.iconUrl } }),
                                h('div', { class: 'preview-info-text' }, [
                                    h('p', { class: 'preview-info-title', attrs: { title: item.title } }, item.title),
                                    h('p', { class: 'preview-info-description', attrs: { title: item.description } }, item.description),
                                ]),
                                h(Button, { class: 'preview-info-button', props: { type: 'primary', size: 'small' } }, item.buttonText),
                            ]),
                        ]),
                    width: 320 + 40 > 418 ? 320 + 40 : 418,
                    okText: '关闭',
                });
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
.creative-library {
    .selected-count {
        color: $impColor;
        font-weight: bold;
        margin: 0.05rem;
    }
    .ivu-modal-body {
        overflow: auto;
        max-height: 80vh;
        border-top: 1px solid #dfe2e5;
        border-bottom: 1px solid #dfe2e5;
    }
    .function-bar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0.1rem;
        .function-item {
            display: flex;
            align-items: cneter;
            margin-left: 0.15rem;
            .function-label {
                display: flex;
                align-items: center;
                white-space: nowrap;
            }
            .function-select {
                width: 120px !important;
                .showregular {
                    width: 108px !important;
                }
                &.long {
                    width: 200px !important;
                    .showregular {
                        width: 155px !important;
                    }
                }
                &.middle {
                    width: 170px !important;
                    .showregular {
                        width: 125px !important;
                    }
                }
            }
        }
    }
    .scroll-box {
        position: relative;
        display: flex;
        justify-content: center;
    }
    $imgSize: 130px;
    .creative-list {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        width: 100%;
        overflow: auto;
        align-content: flex-start;
        height: $imgSize * 3 + 30px;
        &.no-data {
            align-items: center;
            justify-content: center;
            font-size: 0.16rem;
        }
        .creative-item {
            cursor: pointer;
            position: relative;
            display: flex;
            width: $imgSize;
            height: $imgSize;
            margin: 5px;
            align-items: center;
            justify-content: center;
            border: 2px solid #dfe2e5;
            border-radius: 5px;
            & > img {
                max-width: $imgSize - 20px;
                max-height: $imgSize - 20px;
                width: auto;
            }
            &.selected {
                border: 2px solid $impColor;
            }
            .icon-preview {
                padding: 2px;
                position: absolute;
                bottom: -6px;
                right: 3px;
                font-size: 0.2rem;
                color: #999999;
                cursor: zoom-in;
            }
        }
    }

    .footer {
        padding-left: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.14rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/NewPromotion/library.vue